var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.475 27.1342H29.9563L37.9063 35.1217C38.675 35.8904 38.675 37.1467 37.9063 37.9154C37.1375 38.6842 35.8813 38.6842 35.1125 37.9154L27.1438 29.9467V28.4654L26.6375 27.9404C24.0125 30.1904 20.4313 31.3529 16.625 30.7154C11.4125 29.8342 7.25 25.4842 6.6125 20.2342C5.6375 12.3029 12.3125 5.62792 20.2438 6.60292C25.4938 7.24042 29.8438 11.4029 30.725 16.6154C31.3625 20.4217 30.2 24.0029 27.95 26.6279L28.475 27.1342ZM10.2688 18.6967C10.2688 23.3654 14.0375 27.1342 18.7063 27.1342C23.375 27.1342 27.1438 23.3654 27.1438 18.6967C27.1438 14.0279 23.375 10.2592 18.7063 10.2592C14.0375 10.2592 10.2688 14.0279 10.2688 18.6967Z",
    fill: "#652784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.ead7639dc000ad6fc35cd82593406dce.svg";
export { ForwardRef as ReactComponent };